/**
 * Created by Alex Poh. on 20/04/20.
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import { TaskListComponent } from 'src/app/shared/components/task-list/task-list.component';
import { first } from 'rxjs/operators';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'curr-school-admin-dashboard',
  templateUrl: './school-admin-dashboard.component.html',
  styleUrls: ['./school-admin-dashboard.component.scss']
})
export class SchoolAdminDashboardComponent implements OnInit {

  @ViewChild('tasksList')
  tasksList!: TaskListComponent;
  preselectedCourseId: string;
  chartAverageBenchmark: string;
  hasMultipleSchoolsAccess = false;
  studentsTableFilters: { subject: string; studyYearId: number; courseId: number, schoolYearSettingsId?: number };
  currentUserProfile: any;
  showTabs = false;

  constructor(private userService: UserService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.currentUserProfile = this.route.snapshot.data.currentUserProfile;

    if (this.currentUserProfile.user_type === 'SCHOOL_ADMIN' && !this.currentUserProfile.multipleSchoolsAccess) {
      this.showTabs = this.currentUserProfile.permissions.beTeacher;
    }

    this.userService.getCurrUserProfileInfo()
      .pipe(first())
      .subscribe(resp => {
        if (resp.multipleSchoolsAccess) {
          this.hasMultipleSchoolsAccess = true;
          return;
        }

        this.hasMultipleSchoolsAccess = resp.permissions.schoolStatistics;
      });
  }

  addNewTask(): void {
    this.tasksList.addNew();
  }

  studentsTableFiltersChange(data: { subject: string; studyYearId: number; courseId: number, schoolYearSettingsId?: number }): void {
    this.studentsTableFilters = data;
  }

  assessmentResultsMarkChange(data: string): void {
    this.chartAverageBenchmark = data;
  }
}
